module.exports = __webpack_public_path__ + "i18n/ko.faddbd36efe24c1780c658e40f82df36.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ko.json
// module id = 1005
// module chunks = 60